var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-view response"},[_c('ProgressCard',{attrs:{"patient":_vm.patient}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }